<mat-dialog-content>
    <section class="payroll-approvals-dialog-wrapper">
        <h2 class="cmn-popup-title">{{status === 1 ? 'Approval': status === 2 ?'Rejection' : 'Withdrawal'}} Note</h2>
        <button class="cmn-close" mat-dialog-close ></button>
        <!-- form div -->
        <form [formGroup] = "applyApprovalForm">
        <div>
            <div class="payroll-form-wrapper">
                <div class="form-wrapper">
                    <label for="">Notes</label>
                    <mat-form-field >
                        <textarea matInput formControlName= "approvalNote" placeholder="{{status === 1 ? 'Approval': status === 2 ?'Rejection' : 'Withdrawal'}} Note"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="btn-wrapper">
            <button type="submit"  class="cmn-popup-btn" (click)="handleClick()">
                {{status === 1 ? 'Approve': status === 2 ?'Reject' : 'Withdraw'}}
              </button>
              
          </div>
        </form>
        <!-- form div -->
    </section>
</mat-dialog-content>